import { datadogRum } from '@datadog/browser-rum';
import { useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useFeatureFlags } from '|/app/services/launch-darkly/useFeatureFlags';
import useIsInBucket from '|/hooks/use-is-in-bucket';

export const OPD_SEPARATION_EXPERIMENT = 'uw-verifx-opdds';

// insurance-quote still lives in Checkout.UI, not the OPD MFE. It reads referral/consent
// from the order-placed Redux slice, which only the in-monorepo (control) OPD populates on
// mount — the separately-bundled MFE has its own store and can't. Force control on this
// route until insurance-quote fetches that data itself.
const INSURANCE_QUOTE_ROUTE = 'order-placed/insurance-quote';

export const useOpdShellMode = () => {
  const { opdPurchaseUiSeparation: ldFlagEnabled } = useFeatureFlags();
  const isInTreatment = useIsInBucket(ldFlagEnabled ? OPD_SEPARATION_EXPERIMENT : '', 'treatment', [
    'control'
  ]);
  const { pathname } = useLocation();
  const hasTracked = useRef(false);

  const isInsuranceQuoteRoute = pathname.includes(INSURANCE_QUOTE_ROUTE);
  const shellModeAllowed = ldFlagEnabled && isInTreatment === true && !isInsuranceQuoteRoute;
  const isLoading = ldFlagEnabled && isInTreatment === null;

  useEffect(() => {
    if (ldFlagEnabled && isInTreatment !== null && !hasTracked.current) {
      hasTracked.current = true;
      datadogRum.addAction('opd-shell-mode-resolved', {
        bucket: isInTreatment ? 'treatment' : 'control',
        shellModeAllowed,
        ldFlagEnabled
      });
    }
  }, [isInTreatment, shellModeAllowed, ldFlagEnabled]);

  return { shellModeAllowed, isLoading };
};
